module.exports = __webpack_public_path__ + "img/landing-frame-01.24ac8624.png";